"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointClient = void 0;
class EndpointClient {
    get(url, config) {
        return this.request(Object.assign({ method: 'GET', url }, config));
    }
    delete(url, config) {
        return this.request(Object.assign({ method: 'DELETE', url }, config));
    }
    post(url, data, config) {
        return this.request(Object.assign({ method: 'POST', url, data }, config));
    }
    put(url, data, config) {
        return this.request(Object.assign({ method: 'PUT', url, data }, config));
    }
    patch(url, data, config) {
        return this.request(Object.assign({ method: 'PATCH', url, data }, config));
    }
}
exports.EndpointClient = EndpointClient;
//# sourceMappingURL=EndpointClient.js.map